/* @ngInject */
export default function GraphPanelLatestReading($filter) {
  return function (data, decimalDigits) {
    if (_.isArray(data) && _.has(data, [1])) { // for aggregated data
      return $filter('number')(data[1], decimalDigits);
    }
    if (_.isBoolean(data)) {
      return data;
    }
    return $filter('number')(data, decimalDigits); // for normal data
  };
}
